import React, { useState } from "react";
import { fmtCurrency, fmtNumber } from "./analyticsUtils";

const TABS = [
    {
        key: "stockout",
        label: "Stockout Risk",
        icon: "fa-triangle-exclamation",
        cls: "text-red-600",
        activeCls: "border-red-500 text-red-600",
    },
    {
        key: "overstock",
        label: "Overstock",
        icon: "fa-layer-group",
        cls: "text-amber-600",
        activeCls: "border-amber-500 text-amber-600",
    },
    {
        key: "dead_stock",
        label: "Dead Stock",
        icon: "fa-ban",
        cls: "text-slate-500",
        activeCls: "border-slate-500 text-slate-700",
    },
];

const Row = ({ tab, item }) => (
    <div className="flex items-center justify-between py-2 border-b border-slate-50 last:border-0">
        <div className="min-w-0 pr-2">
            <p className="text-[13px] font-semibold text-slate-700 truncate">{item.description}</p>
            <p className="text-[11px] text-slate-400">{item.upc} · {item.department}</p>
        </div>
        <div className="text-right flex-shrink-0">
            {tab === "stockout" ? (
                <>
                    <p className="text-[13px] font-bold text-red-600">
                        {item.days_of_cover === null ? "—" : `${item.days_of_cover}d cover`}
                    </p>
                    <p className="text-[11px] text-slate-400">
                        On hand {fmtNumber(item.on_hand)} · order {fmtNumber(item.suggested_order_qty)}
                    </p>
                </>
            ) : (
                <>
                    <p className="text-[13px] font-bold text-slate-700">{fmtNumber(item.on_hand)} on hand</p>
                    <p className="text-[11px] text-slate-400">
                        {fmtCurrency(item.on_hand * (item.each_cost || 0))} tied up
                    </p>
                </>
            )}
        </div>
    </div>
);

const AlertsPanel = ({ alerts, loading }) => {
    const [tab, setTab] = useState("stockout");
    const counts = alerts?.counts || {};
    const rows = alerts?.[tab] || [];

    return (
        <div className="bg-white rounded-2xl shadow-1 p-4 h-full flex flex-col">
            <h3 className="font-bold text-slate-800 text-[15px] mb-3">
                <i className="fa-solid fa-bell text-[var(--color-2)] mr-2" />
                Decision Alerts
            </h3>

            <div className="flex border-b border-slate-100 mb-2">
                {TABS.map((t) => (
                    <button
                        key={t.key}
                        onClick={() => setTab(t.key)}
                        className={`flex-1 pb-2 text-[12px] font-semibold border-b-2 -mb-px transition-colors ${
                            tab === t.key ? t.activeCls : "border-transparent text-slate-400"
                        }`}
                    >
                        <i className={`fa-solid ${t.icon} mr-1`} />
                        {t.label}
                        <span className="ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-slate-100 text-slate-600 text-[10px]">
                            {counts[t.key] ?? 0}
                        </span>
                    </button>
                ))}
            </div>

            <div className="flex-1 overflow-y-auto my-scroll min-h-[220px]">
                {loading ? (
                    <div className="h-[220px] flex-center text-slate-400 text-[13px]">Loading…</div>
                ) : rows.length === 0 ? (
                    <div className="h-[220px] flex-center flex-col text-slate-400 text-[13px] gap-2">
                        <i className="fa-solid fa-circle-check text-green-400 text-2xl" />
                        No {TABS.find((t) => t.key === tab)?.label.toLowerCase()} items.
                    </div>
                ) : (
                    rows.map((item) => <Row key={item.upc} tab={tab} item={item} />)
                )}
            </div>
        </div>
    );
};

export default AlertsPanel;
